"use client";

import React from "react";
import { ArrowUpRight } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const ministriesData = [{
  id: "alliance",
  title: "ALIANZA DE LAS AD PARA LA EDUCACIÓN SUPERIOR",
  description: "Ofrecemos información sobre universidades de las AD.",
  buttonText: "MÁS INFORMACIÓN",
  href: "#",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/education_ministry_students.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/education_ministry_students.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/education_ministry_students.png-wvc-sizes",
  alt: "Estudiantes universitarios de la Alianza de Educación Superior"
}, {
  id: "holy-land",
  title: "CENTRO PARA EL ESTUDIO DE LA TIERRA SANTA",
  description: "Experimenta a Dios a través de las tierras de la Biblia.",
  buttonText: "MÁS INFORMACIÓN",
  href: "#",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/education_ministry_holy_land.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/education_ministry_holy_land.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/education_ministry_holy_land.png-wvc-sizes",
  alt: "Centro para el Estudio de la Tierra Santa en Jerusalén"
}];
export default function EducationMinistries() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="educationministriesgrid" data-nav="light" className="bg-background py-12 md:py-16 lg:py-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-2 max-w-4xl">
          {ministriesData.map((item, i) => <motion.div key={item.id} data-index={i} initial={shouldReduceMotion ? {
          opacity: 1
        } : {
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.5,
          delay: i * 0.15
        }} className="group relative flex flex-col justify-end overflow-hidden rounded-3xl bg-muted shadow-md transition-[box-shadow] duration-300 hover:shadow-xl min-h-[480px] sm:min-h-[520px] md:min-h-[560px] border-b-4 border-b-primary">
              {}
              <div className="absolute inset-0 h-full w-full overflow-hidden">
                <img src={item.image} data-wvc-srcset={item.srcset} data-wvc-sizes={item.sizes} alt={item.alt} loading="lazy" decoding="async" className="h-full w-full object-cover object-center transition-transform duration-500 ease-out group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-black/10" />
              </div>

              {}
              <div className="absolute top-4 right-4 z-10">
                <Link to={item.href} className="flex size-11 items-center justify-center rounded-full bg-background/95 text-foreground shadow-md backdrop-blur-xs transition-[background-color,transform,color] duration-300 hover:bg-primary hover:text-primary-foreground group-hover:scale-110" aria-label={`Ir a ${item.title}`}>
                  <ArrowUpRight className="size-5" />
                </Link>
              </div>

              {}
              <div className="relative z-10 m-3 sm:m-4 rounded-2xl bg-card p-5 sm:p-6 text-card-foreground shadow-lg backdrop-blur-sm">
                <h3 className="font-default text-lg sm:text-xl font-bold tracking-tight text-foreground uppercase leading-snug">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm sm:text-base text-muted-foreground leading-relaxed">
                  {item.description}
                </p>

                <div className="mt-5">
                  <Button asChild size="sm" className="rounded-full bg-foreground text-background hover:bg-foreground/90 font-medium text-xs tracking-wider uppercase px-5 py-2.5 h-auto transition-[background-color,box-shadow]">
                    <Link to={item.href} className="inline-flex items-center gap-2">
                      <span>{item.buttonText}</span>
                      <span className="flex size-4 items-center justify-center rounded-full bg-background text-foreground">
                        <ArrowUpRight className="size-3" />
                      </span>
                    </Link>
                  </Button>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}